export { default } from './LabelIconStart'
